import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

const tableStyles = `
.pit-wrap { overflow-x:auto; }
.pit-title { font-size:11px; font-weight:700; color:#1890ff; letter-spacing:1px; text-transform:uppercase; margin-bottom:10px; display:flex; align-items:center; gap:6px; }

.pit-table { width:100%; border-collapse:collapse; font-size:12px; }
.pit-table thead tr { background:#f0f7ff; }
.pit-table thead th { padding:8px 12px; font-size:10px; font-weight:700; color:#1890ff; letter-spacing:1px; text-transform:uppercase; border:1px solid #e6f0ff; white-space:nowrap; text-align:center; }
.pit-table tbody td { padding:8px 12px; border:1px solid #e6f0ff; font-size:12px; color:#262626; font-weight:500; vertical-align:middle; }
.pit-table tbody tr:nth-child(even) td { background:#f7f9ff; }
.pit-table tbody tr:hover td { background:#e6f7ff!important; }

/* Total row */
.pit-total td { background:#f0f7ff!important; font-weight:700!important; color:#0050b3!important; border-top:2px solid #d6e8ff!important; }

/* Empty */
.pit-empty td { text-align:center; color:#8c8c8c; font-style:italic; padding:20px!important; }

/* Amount cell */
.pit-amount { font-weight:700; color:#0050b3; font-family:monospace; }
.pit-budget { font-weight:600; color:#d46b08; font-family:monospace; }
`;

const PrItemTable = ({ prItems }) => (
  <>
    <style>{tableStyles}</style>
    <div className="pit-wrap">
      <table className="pit-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Material Specification</th>
            <th>Unit</th>
            <th>Currency</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Amount</th>
            <th>Date Needed</th>
            <th>Budget Price</th>
          </tr>
        </thead>
        <tbody>
          {prItems.length === 0 ? (
            <tr className="pit-empty">
              <td colSpan="9">
                <Icon type="inbox" style={{ fontSize: 20, marginBottom: 4, display: 'block', margin: '0 auto 4px' }} />
                NO RECORD
              </td>
            </tr>
          ) : (
            <>
              {prItems.map(item => (
                <tr key={item.id}>
                  <td>{item.code}</td>
                  <td>{item.mspecs}</td>
                  <td style={{ textAlign: 'center' }}>{item.unit}</td>
                  <td style={{ textAlign: 'center' }}>{item.currency}</td>
                  <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                  <td style={{ textAlign: 'right' }}>{item.unitPrice}</td>
                  <td style={{ textAlign: 'right' }}><span className="pit-amount">{item.amount.toFixed(2)}</span></td>
                  <td style={{ textAlign: 'center' }}>{item.dateNeeded}</td>
                  <td style={{ textAlign: 'right' }}><span className="pit-budget">{item.budgetPrice}</span></td>
                </tr>
              ))}
              <tr className="pit-total">
                <td colSpan="6" />
                <td style={{ textAlign: 'right' }}>
                  {prItems.reduce((acc, val) => acc + val.amount, 0).toFixed(2)}
                </td>
                <td colSpan="2" />
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  </>
);

PrItemTable.propTypes = {
  prItems: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PrItemTable;